module.exports = __webpack_public_path__ + "static/media/send-letter-info-img5.d0a23a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-info-img5.png
// module id = 1319
// module chunks = 1